import React from 'react'
import { StreamData } from 'types/streamData'
import Domain from 'enums/Domain'
import StreamSymbol from 'enums/StreamSymbol'
import Author from './Author'
import RedditAuthor from './RedditAuthor'
import LxnxAuthor from './LxnxAuthor'

type AuthorComponentProps = {
  streamData: StreamData
}

const AuthorComponent = ({ streamData }: AuthorComponentProps) => {
  const {
    isRetweet,
    originalAuthorUrl,
    originalAuthorName,
    originalAuthorHandle,
    originalAuthorVerified,
    authorUrl,
    authorVerified,
    authorName,
    authorHandle,
    domain,
    dataStream,
    sourceName
  } = streamData

  if (isRetweet) {
    return (
      <Author
        name={originalAuthorName}
        handle={originalAuthorHandle}
        url={originalAuthorUrl}
        verified={originalAuthorVerified}
      />
    )
  }

  if (domain === Domain.REDDIT) {
    return <RedditAuthor name={authorName!} sourceName={sourceName!} url={authorUrl!} />
  }

  if (dataStream === StreamSymbol.LXNX) {
    return <LxnxAuthor name={authorName} sourceName={sourceName!} />
  }

  return (
    <Author name={authorName} handle={authorHandle} url={authorUrl} verified={authorVerified} />
  )
}

export default AuthorComponent
